export const getFileSizeDisplayText = (
  sizeInBytes: string | number | undefined,
  decimalPlaces: number = 1
): string => {
  if (sizeInBytes === undefined || sizeInBytes === null) {
    return '0 B'
  }
  
  const size = typeof sizeInBytes === 'string' ? parseInt(sizeInBytes, 10) : sizeInBytes
  
  if (isNaN(size) || size < 0) {
    return '0 B'
  }
  if (size === 0) return '0 B'
  
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const base = 1024
  
  const unitIndex = Math.floor(Math.log(size) / Math.log(base))
  const finalSize = size / Math.pow(base, unitIndex)
  
  if (unitIndex === 0) {
    return `${Math.round(finalSize)} ${units[unitIndex]}`
  }
  
  return `${finalSize.toFixed(decimalPlaces)} ${units[unitIndex]}`
}